import { Controller } from "@hotwired/stimulus"
import consumer from "../channels/consumer"

export default class extends Controller {
  static targets = ["count", "bar", "container", "submitButton", "limitMessage"]
  static values = { userId: Number }

  connect() {
    if (this.hasUserIdValue) {
      this.subscription = consumer.subscriptions.create(
        { channel: "UsageChannel", user_id: this.userIdValue },
        {
          received: (data) => {
            this.handleUpdate(data)
          }
        }
      )
    }
  }

  disconnect() {
    if (this.subscription) {
      this.subscription.unsubscribe()
    }
  }

  handleUpdate(data) {
    if (data.type === "usage_update") {
      this.updateDisplay(data)
    }
  }

  updateDisplay(data) {
    // カウンター更新
    if (this.hasCountTarget) {
      this.countTarget.textContent = `${data.current} / ${data.limit}`
    }

    // プログレスバー更新
    if (this.hasBarTarget) {
      this.barTarget.style.width = `${data.percentage}%`

      // 色の変更（80%超えたら黄色、100%で赤）
      this.barTarget.classList.remove("bg-blue-500", "bg-yellow-500", "bg-red-500")
      if (data.percentage >= 100) {
        this.barTarget.classList.add("bg-red-500")
      } else if (data.percentage >= 80) {
        this.barTarget.classList.add("bg-yellow-500")
      } else {
        this.barTarget.classList.add("bg-blue-500")
      }
    }

    // 制限到達時の制御
    if (data.remaining <= 0) {
      this.disableInput()
      if (this.hasLimitMessageTarget) {
        this.limitMessageTarget.classList.remove("hidden")
      }
    } else {
      this.enableInput()
      if (this.hasLimitMessageTarget) {
        this.limitMessageTarget.classList.add("hidden")
      }
    }
  }

  disableInput() {
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = true
      this.submitButtonTarget.classList.add("opacity-50", "cursor-not-allowed")
    }
  }

  enableInput() {
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = false
      this.submitButtonTarget.classList.remove("opacity-50", "cursor-not-allowed")
    }
  }
}
